export const JOB_YARN_IN_OUT_REPORT_REQUEST = 'JOB_YARN_IN_OUT_REPORT_REQUEST';
export const JOB_YARN_IN_OUT_REPORT_SUCCESS = 'JOB_YARN_IN_OUT_REPORT_SUCCESS';
export const JOB_YARN_IN_OUT_REPORT_FAILURE = 'JOB_YARN_IN_OUT_REPORT_FAILURE';
export const JOB_YARN_IN_OUT_FILTER_REPORT_REQUEST = 'JOB_YARN_IN_OUT_FILTER_REPORT_REQUEST';
export const JOB_YARN_IN_OUT_FILTER_REPORT_SUCCESS = 'JOB_YARN_IN_OUT_FILTER_REPORT_SUCCESS';
export const JOB_YARN_IN_OUT_FILTER_REPORT_FAILURE = 'JOB_YARN_IN_OUT_FILTER_REPORT_FAILURE';